import { supportCode } from "@/components/error-screen";
import { ApiError } from "@/lib/api-client";

/**
 * The state a list or panel shows when its query fails: a translated title, and
 * the request ID of a 5xx as a support code. The server's message never reaches
 * the screen.
 */
export function loadErrorState(error: unknown, title: string, supportCodeLabel: string) {
  const code = supportCode(error, supportCodeLabel);
  return { title, description: code ? `${code.label}: ${code.value}` : undefined };
}

/**
 * The detail line under the title of a failed action. A 4xx carries a message
 * the API wrote for the person (it arrives translated from the client, e.g.
 * "an analysis is already running for this app"); a 5xx gets the support code.
 */
export function actionErrorDetail(error: unknown, supportCodeLabel: string): string | undefined {
  if (error instanceof ApiError && error.status < 500) return error.message;
  return loadErrorState(error, "", supportCodeLabel).description;
}
